import { render, staticRenderFns } from "./AddScopeOfPracticeCategoryModal.vue?vue&type=template&id=7c57046a&scoped=true&"
import script from "./AddScopeOfPracticeCategoryModal.vue?vue&type=script&lang=js&"
export * from "./AddScopeOfPracticeCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c57046a",
  null
  
)

export default component.exports